import { FormField, FormSearchSelect } from "@NP-Webber/crm-kit";
import type { LookupOption } from "./useLookupOptions";

export type LookupSelectProps = {
  label: string;
  value: string;
  onChange: (key: string) => void;
  options: LookupOption[];
  /** search = FormSearchSelect; fixed = FormField type=select for short lists */
  variant?: "search" | "fixed";
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  noOptionsText?: string;
  allowEmpty?: boolean;
  emptyLabel?: string;
};

export function LookupSelect({
  label,
  value,
  onChange,
  options,
  variant = "search",
  disabled = false,
  required = false,
  placeholder,
  noOptionsText = "אין אפשרויות",
  allowEmpty = true,
  emptyLabel = "—",
}: LookupSelectProps) {
  if (variant === "fixed") {
    const selectOptions = [
      ...(allowEmpty ? [{ value: "", label: emptyLabel }] : []),
      ...options.map((o) => ({ value: o.key, label: o.labelHe })),
    ];
    return (
      <FormField
        label={label}
        type="select"
        required={required}
        value={value}
        onChange={onChange}
        disabled={disabled}
        options={selectOptions}
      />
    );
  }

  const selected = options.find((o) => o.key === value) ?? null;
  return (
    <FormSearchSelect
      label={label}
      required={required}
      options={options}
      value={selected}
      onChange={(option) => {
        const selectedOption = option as LookupOption | null;
        onChange(selectedOption?.key ?? "");
      }}
      getOptionLabel={(option) =>
        String((option as LookupOption | null)?.labelHe ?? "")
      }
      isOptionEqual={(a, b) =>
        (a as LookupOption | null)?.key === (b as LookupOption | null)?.key
      }
      placeholder={placeholder ?? `חיפוש ${label}`}
      noOptionsText={noOptionsText}
      disabled={disabled}
    />
  );
}

export const BILLING_DAY_OPTIONS = Array.from({ length: 28 }, (_, i) => {
  const day = String(i + 1);
  return { value: day, label: day };
});

export const CONTACT_ROLE_KEY_OPTIONS = [
  { value: "primary", label: "ראשי" },
  { value: "secondary", label: "משני" },
  { value: "reference", label: "לייחוס" },
];
